import { SearchableDropdown } from './SearchableDropdown';

interface ThemeTypeDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function ThemeTypeDropdown({
  value,
  onChange,
  placeholder = 'Select Theme Type',
  className,
}: ThemeTypeDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search theme types..."
      className={className}
      endpoint="theme-types"
      emptyText="No theme types found."
    />
  );
}
